export const isReactNativeApp = () => window?.ReactNativeWebView && typeof window?.ReactNativeWebView?.postMessage === 'function';

export const postReactNativeMessage = string => {
  window.ReactNativeWebView.postMessage(string);
};

export const getMobileOS = () => {
  if (/android/.test(navigator.platform)) {
    return 'Android';
  }
  if (/iPhone|iPod|iPad|Mac/.test(navigator.platform)) {
    return 'iOS';
  }
  return 'unknown';
};
